import control_event_default from "../components/controls/control_event.vue.js";
import _sfc_main from "../components/controls/control_slot.vue.js";
import _sfc_main$1 from "../components/controls/control_selection.vue.js";
import _sfc_main$2 from "../components/controls/control_dynamic.vue.js";
import _sfc_main$3 from "../components/controls/control_string.vue.js";
import { typeOfMemberValue } from "./utils.js";
import _sfc_main$4 from "../components/controls/control_object.vue.js";
import _sfc_main$5 from "../components/controls/control_array.vue.js";
import _sfc_main$6 from "../components/controls/control_boolean.vue.js";
import _sfc_main$7 from "../components/controls/control_number.vue.js";
import _sfc_main$8 from "../components/controls/control_nullish.vue.js";
import _sfc_main$9 from "../components/controls/control_base.vue.js";
import _sfc_main$10 from "../components/controls/control_icon_slot.vue.js";
import _sfc_main$11 from "../components/controls/control_segmented.vue.js";
//#region src/lib/control.js
/**
* See /.github/documentation/internal/CONTROLS.MD
* For in-depth information about controls.
*/
var MAX_SEGMENTED_COUNT = 6;
var MAX_SEGMENTED_LABEL_LENGTH = 4;
/**
* Symbol representing a value that is "not set".
* The main usage is to indicate that a prop value should be 'undefined' instead of using its default value.
*
* @type {symbol}
*/
var UNSET = Symbol("unset");
/**
* Map of controls containing control component and related information.
* Controls must have the 'component' and 'default' entries.
*
* @type {object}
*/
var controlMap = Object.freeze({
	event: {
		component: control_event_default,
		default() {
			return null;
		}
	},
	slot: {
		component: _sfc_main,
		default() {
			return getControlDataDefault(this);
		}
	},
	dynamic: {
		component: _sfc_main$2,
		default() {
			return getControlDataDefault(this);
		},
		defaultControl() {
			return "undefined";
		},
		serialize: true
	},
	object: {
		component: _sfc_main$4,
		default() {
			return getControlDataDefault(this);
		}
	},
	array: {
		component: _sfc_main$5,
		default() {
			return getControlDataDefault(this);
		}
	},
	selection: {
		component: _sfc_main$1,
		default({ values } = {}) {
			return values?.[0];
		}
	},
	segmented: {
		component: _sfc_main$11,
		default({ values } = {}) {
			return values?.[0];
		}
	},
	string: {
		component: _sfc_main$3,
		default() {
			return getControlDataDefault(this);
		}
	},
	number: {
		component: _sfc_main$7,
		default() {
			return getControlDataDefault(this);
		}
	},
	boolean: {
		component: _sfc_main$6,
		default() {
			return getControlDataDefault(this);
		}
	},
	null: {
		component: _sfc_main$8,
		default() {
			return getControlDataDefault(this);
		},
		serialize: true
	},
	base: {
		component: _sfc_main$9,
		default() {
			return getControlDataDefault(this);
		}
	},
	"icon-slot": {
		component: _sfc_main$10,
		default() {
			return null;
		}
	}
});
function getControlDataDefault(controlData) {
	return controlData.component.props.value.default();
}
function getControlByValue(value) {
	const control = value === void 0 || value === null || value === UNSET ? "null" : typeOfMemberValue(value);
	return control in controlMap ? control : "base";
}
function getControlByMemberType(type, args) {
	if (type === "boolean") return "boolean";
	if (args?.values?.length > 0) {
		if (shouldUseSegmented(args.values)) return "segmented";
		return "selection";
	}
	switch (type) {
		case "string": return "string";
		default: return type;
	}
}
function shouldUseSegmented(values) {
	return values.length <= MAX_SEGMENTED_COUNT && values.every((v) => String(v).length <= MAX_SEGMENTED_LABEL_LENGTH);
}
/**
* Serializes a value before giving it to a control that requires a serialized value.
* Currently, this only converts between 'UNSET' and 'undefined'.
*
* @param {*} value - The value to serialize
* @returns {*} The serialized value
*/
function serializeControlValue(value) {
	return value === void 0 ? UNSET : value;
}
/**
* Deserializes a value after receiving it from a control that requires a serialized value.
* Currently, this only converts between 'UNSET' and 'undefined'.
*
* @param {*} value - The value to deserialize
* @returns {*} The deserialized value
*/
function deserializeControlValue(value) {
	return value === UNSET ? void 0 : value;
}
//#endregion
export { UNSET, controlMap, deserializeControlValue, getControlByMemberType, getControlByValue, serializeControlValue };

//# sourceMappingURL=control.js.map